var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/helpers/date.ts
var date_exports = {};
__export(date_exports, {
  addBusDays: () => addBusDays,
  addDays: () => addDays,
  default: () => date_default,
  eachDayOfInterval: () => eachDayOfInterval,
  eachDayOfIntervalAsRunnDates: () => eachDayOfIntervalAsRunnDates,
  formatDatabaseDateToRunnDate: () => formatDatabaseDateToRunnDate,
  formatToRunnDate: () => formatToRunnDate,
  formatToRunnNumDate: () => formatToRunnNumDate,
  getAllWeekdaysDatesBetween: () => getAllWeekdaysDatesBetween,
  getDayNumberFromStartDate: () => getDayNumberFromStartDate,
  getLengthOfTimeInWeeks: () => getLengthOfTimeInWeeks,
  getNumberOfWeekDaysInMonth: () => getNumberOfWeekDaysInMonth,
  getTimesheetLockedToDate: () => getTimesheetLockedToDate,
  getTodaysDate: () => getTodaysDate,
  getWeekNumberFromStartDate: () => getWeekNumberFromStartDate,
  isWeekend: () => isWeekend,
  parseDatabaseDate: () => parseDatabaseDate,
  parseRunnDate: () => parseRunnDate,
  readableRunnDate: () => readableRunnDate,
  subBusDays: () => subBusDays,
  subDays: () => subDays
});
import {
  addBusinessDays,
  addDays as addDaysDateFns,
  differenceInCalendarDays,
  differenceInCalendarWeeks,
  eachDayOfInterval as eachDayOfIntervalDateFns,
  endOfMonth,
  format,
  isAfter,
  isMonday,
  isSameWeek,
  isSaturday,
  isSunday,
  parseISO,
  startOfMonth,
  startOfToday,
  subBusinessDays,
  subDays as subDaysDateFns
} from "date-fns";
import { match } from "ts-pattern";

// src/helpers/error.ts
var report = (level, error, meta, errorObject) => {
  console.log("reportError", error, error.message, meta);
  const rollbar = window?.Rollbar;
  if (!rollbar) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const args = [error, meta, errorObject, resolve].filter(Boolean);
    rollbar[level](...args);
  });
};
var reportError = (error, meta, errorObject) => report("error", error, meta, errorObject);

// src/helpers/date.ts
var parseRunnDate = (input, options) => {
  const date = input;
  const utc = options?.utc ?? false;
  if (date instanceof Date) {
    return date;
  }
  if (typeof date !== "string" || date.length !== 8) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const dateNum = Number.parseInt(date, 10);
  const year = dateNum / 1e4;
  const month = dateNum / 100 % 100 - 1;
  const day = dateNum % 100;
  if (utc) {
    return new Date(Date.UTC(year, month, day));
  }
  return new Date(year, month, day);
};
var parseDatabaseDate = (input) => {
  const date = input;
  if (date instanceof Date) {
    return date;
  }
  if (typeof date !== "string" || date.length !== 10) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const isoDateTime = date + "T00:00:00.000";
  return new Date(isoDateTime);
};
var formatToRunnDate = (date) => {
  if (!date) {
    return "";
  }
  if (typeof date === "string") {
    return date;
  }
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  let day = date.getDate();
  if (day < 10) {
    day = `0${day}`;
  }
  return `${year}${month}${day}`;
};
var formatToRunnNumDate = (date) => Number(format(date, "yyyyMMdd"));
var formatDatabaseDateToRunnDate = (date) => date.replace(/-/g, "");
var readableRunnDate = (date) => {
  return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
};
var addDays = (date, days) => {
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  return formatToRunnDate(addDaysDateFns(dateDate, days));
};
var subDays = (date, days) => {
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  return formatToRunnDate(subDaysDateFns(dateDate, days));
};
var addBusDays = (date, days) => {
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  return formatToRunnDate(addBusinessDays(dateDate, days));
};
var subBusDays = (date, days) => {
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  return formatToRunnDate(subBusinessDays(dateDate, days));
};
var isWeekend = (date) => {
  const dateObject = parseRunnDate(date);
  if (isSaturday(dateObject) || isSunday(dateObject)) {
    return true;
  }
  return false;
};
var getTodaysDate = () => formatToRunnDate(/* @__PURE__ */ new Date());
var eachDayOfInterval = (dates, name, metadata, includeWeekends = true) => {
  try {
    const allDays = eachDayOfIntervalDateFns(dates);
    return includeWeekends ? allDays : allDays.filter((day) => !isWeekend(formatToRunnDate(day)));
  } catch (e) {
    void reportError(
      "eachDayOfInterval Error",
      {
        function_name: name,
        item_id: metadata?.id,
        start: dates.start,
        end: dates.end,
        meta: metadata
      },
      e
    );
    throw e;
  }
};
var eachDayOfIntervalAsRunnDates = (dates, name, metadata, includeWeekends = false) => {
  try {
    const allDays = eachDayOfIntervalDateFns(dates);
    let intervalDates = allDays;
    if (!includeWeekends) {
      intervalDates = allDays.filter((day) => !isWeekend(formatToRunnDate(day)));
    }
    return intervalDates.map((date) => formatToRunnDate(date));
  } catch (e) {
    void reportError(
      "eachDayOfIntervalAsRunnDates Error",
      {
        function_name: name,
        item_id: metadata?.id,
        start: dates.start,
        end: dates.end,
        meta: metadata
      },
      e
    );
    throw e;
  }
};
var getNewDateNumber = (dateNumber) => {
  let currentDateNum = dateNumber;
  const dateString = String(currentDateNum);
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  switch (month) {
    case "01":
      if (day === "31") {
        currentDateNum = Number(year + "0201");
      } else {
        currentDateNum++;
      }
      break;
    case "02":
      const numYear = Number(year);
      if (numYear % 4 === 0 && numYear % 100 !== 0 || numYear % 400 === 0) {
        if (day === "29") {
          currentDateNum = Number(year + "0301");
          break;
        }
      } else {
        if (day === "28") {
          currentDateNum = Number(year + "0301");
          break;
        }
      }
      currentDateNum++;
      break;
    case "03":
      if (day === "31") {
        currentDateNum = Number(year + "0401");
      } else {
        currentDateNum++;
      }
      break;
    case "04":
      if (day === "30") {
        currentDateNum = Number(year + "0501");
      } else {
        currentDateNum++;
      }
      break;
    case "05":
      if (day === "31") {
        currentDateNum = Number(year + "0601");
      } else {
        currentDateNum++;
      }
      break;
    case "06":
      if (day === "30") {
        currentDateNum = Number(year + "0701");
      } else {
        currentDateNum++;
      }
      break;
    case "07":
      if (day === "31") {
        currentDateNum = Number(year + "0801");
      } else {
        currentDateNum++;
      }
      break;
    case "08":
      if (day === "31") {
        currentDateNum = Number(year + "0901");
      } else {
        currentDateNum++;
      }
      break;
    case "09":
      if (day === "30") {
        currentDateNum = Number(year + "1001");
      } else {
        currentDateNum++;
      }
      break;
    case "10":
      if (day === "31") {
        currentDateNum = Number(year + "1101");
      } else {
        currentDateNum++;
      }
      break;
    case "11":
      if (day === "30") {
        currentDateNum = Number(year + "1201");
      } else {
        currentDateNum++;
      }
      break;
    case "12":
      if (day === "31") {
        currentDateNum = Number(`${Number(year) + 1}0101`);
      } else {
        currentDateNum++;
      }
      break;
    default:
      currentDateNum++;
  }
  return currentDateNum;
};
var getAllWeekdaysDatesBetween = (start, end) => {
  const dates = [];
  let startDate = typeof start === "string" ? parseRunnDate(start) : start;
  const endDate = typeof end === "string" ? parseRunnDate(end) : end;
  if (isSunday(startDate)) {
    startDate = addDaysDateFns(startDate, 1);
  }
  if (isSaturday(startDate)) {
    startDate = addDaysDateFns(startDate, 2);
  }
  let currentDate = startDate;
  while (!isMonday(currentDate)) {
    if (isAfter(currentDate, endDate)) {
      return dates;
    }
    if (!isSaturday(currentDate) && !isSunday(currentDate)) {
      dates.push(formatToRunnDate(currentDate));
    }
    currentDate = addDaysDateFns(currentDate, 1);
  }
  const endDateNum = Number(formatToRunnDate(endDate));
  let currentDateNum = Number(formatToRunnDate(currentDate));
  let i = 1;
  while (currentDateNum <= endDateNum) {
    if (i % 7 !== 6 && i % 7 !== 0) {
      dates.push(String(currentDateNum));
    }
    i++;
    currentDateNum = getNewDateNumber(currentDateNum);
  }
  return dates;
};
var getWeekNumberFromStartDate = (start, date) => {
  if (!start || !date) {
    return;
  }
  const startDate = typeof start === "string" ? parseRunnDate(start) : start;
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  const weekNumber = differenceInCalendarWeeks(dateDate, startDate);
  return weekNumber >= 0 ? weekNumber + 1 : weekNumber;
};
var getDayNumberFromStartDate = (start, date) => {
  if (!start || !date) {
    return;
  }
  const startDate = typeof start === "string" ? parseRunnDate(start) : start;
  const dateDate = typeof date === "string" ? parseRunnDate(date) : date;
  const dayNumber = differenceInCalendarDays(dateDate, startDate);
  return dayNumber >= 0 ? dayNumber + 1 : dayNumber;
};
var getLengthOfTimeInWeeks = (start, end) => {
  if (!start || !end) {
    return "\u2014";
  }
  const startDate = typeof start === "string" ? parseRunnDate(start) : start;
  const endDate = typeof end === "string" ? parseRunnDate(end) : end;
  const lengthInWeeks = differenceInCalendarWeeks(endDate, startDate);
  if (lengthInWeeks === 0) {
    const lengthInDays = differenceInCalendarDays(endDate, startDate) + 1;
    return lengthInDays === 1 ? "1 day" : `${lengthInDays} days`;
  }
  return `${lengthInWeeks + 1} weeks`;
};
var getTimesheetLockedToDate = (lockStatus, timesheetStatusUpdatedAt, timesheetAutoLockDate, timesheetManualLockDate) => {
  const today = startOfToday();
  const formattedTimesheetManualLockDate = timesheetManualLockDate?.split("-")?.join("") || null;
  return match({
    lockStatus,
    // locking/unlocking overrides auto-lock settings for the week the action was taken in
    // e.g. if I unlock the timesheets today, they will stay unlocked until the end of the week only
    isSameWeek: isSameWeek(today, parseISO(timesheetStatusUpdatedAt))
  }).with({ lockStatus: "UNLOCKED", isSameWeek: true }, () => null).with(
    { lockStatus: "LOCKED", isSameWeek: true },
    () => formattedTimesheetManualLockDate
  ).otherwise(
    () => Math.max(
      Number(timesheetAutoLockDate),
      Number(formattedTimesheetManualLockDate)
    ).toString()
  );
};
var getNumberOfWeekDaysInMonth = (date) => eachDayOfInterval({
  start: startOfMonth(date),
  end: endOfMonth(date)
}).filter((day) => !isWeekend(formatToRunnDate(day))).length;
var date_default = {
  parseRunnDate,
  parseDatabaseDate,
  formatToRunnDate,
  formatToRunnNumDate,
  getAllWeekdaysDatesBetween,
  addBusDays,
  subBusDays,
  isWeekend,
  getTodaysDate,
  eachDayOfInterval,
  eachDayOfIntervalAsRunnDates,
  addDays,
  subDays,
  getWeekNumberFromStartDate,
  getDayNumberFromStartDate,
  getLengthOfTimeInWeeks,
  getTimesheetLockedToDate,
  getNumberOfWeekDaysInMonth
};

// src/projectTotals/getTimeFrames.ts
import {
  eachDayOfInterval as eachDayOfIntervalDateFns2,
  isBefore,
  isMonday as isMonday2,
  isWeekend as isWeekend2
} from "date-fns";

// src/projectTotals/helpers.ts
var formatToRunnDate2 = (date) => {
  if (typeof date === "string") {
    return date;
  }
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  let day = date.getDate();
  if (day < 10) {
    day = `0${day}`;
  }
  return `${year}${month}${day}`;
};
var parseRunnDate2 = (input) => {
  const date = input;
  if (date instanceof Date) {
    return date;
  }
  if (typeof date !== "string" || date.length !== 8) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const dateNum = Number.parseInt(date, 10);
  const year = dateNum / 1e4;
  const month = dateNum / 100 % 100 - 1;
  const day = dateNum % 100;
  return new Date(year, month, day);
};
var dateIsAHoliday = (timeOffs, date) => timeOffs.some(
  (timeOff) => timeOff.leave_type === "holiday" /* HOLIDAY */ && timeOff.start_date === date
);

// src/projectTotals/getTimeFrames.ts
var eachDayOfInterval2 = (dates, name, metadata) => {
  try {
    return eachDayOfIntervalDateFns2(dates);
  } catch (e) {
    void reportError(
      "eachDayOfInterval Error",
      {
        function_name: name,
        item_id: metadata?.id,
        start: dates.start,
        end: dates.end,
        meta: metadata
      },
      e
    );
    throw e;
  }
};
var getTimeFrames = ({
  start,
  end,
  includeWeekends = true
}) => {
  const startDate = typeof start === "string" ? parseRunnDate2(start) : start;
  const endDate = typeof end === "string" ? parseRunnDate2(end) : end;
  let calendarDates = [];
  if (isBefore(endDate, startDate)) {
    calendarDates = eachDayOfInterval2(
      { start: endDate, end: startDate },
      "getTimeFrames"
    );
  } else {
    calendarDates = eachDayOfInterval2(
      { start: startDate, end: endDate },
      "getTimeFrames"
    );
  }
  if (!includeWeekends) {
    calendarDates = calendarDates.filter((d) => !isWeekend2(d));
  }
  const weeklyDates = calendarDates.filter((d) => isMonday2(d));
  const runnDailyDates = calendarDates.map((date) => ({
    formattedDate: formatToRunnDate2(date)
  }));
  const runnWeeklyDates = weeklyDates.map((date) => ({
    formattedDate: formatToRunnDate2(date)
  }));
  return {
    dailyDates: calendarDates,
    runnDailyDates,
    weeklyDates,
    runnWeeklyDates,
    totalDays: calendarDates.length,
    totalBusinessDays: calendarDates.filter((d) => !isWeekend2(d)).length
  };
};

// src/projectTotals/combinedProjectHours.ts
var dateWithinItem = (date, item) => {
  if (date < item.start_date) {
    return false;
  }
  if (item.end_date && date > item.end_date) {
    return false;
  }
  return true;
};
var getCostOnDay = (date, contracts) => {
  if (!contracts) {
    return 0;
  }
  if (contracts.length === 1) {
    return contracts.at(0)?.cost || contracts.at(0)?.padded_cost || 0;
  }
  const validContract = contracts.find((c) => dateWithinItem(date, c));
  if (validContract) {
    return validContract.cost || validContract.padded_cost || 0;
  }
  return 0;
};
var assignmentsVisibleDaysFilter = (a, days) => {
  if (Number(a.end_date) < Number(days[0])) {
    return false;
  }
  if (Number(a.start_date) > Number(days[days.length - 1])) {
    return false;
  }
  return true;
};
var realPeopleVisibleAssignmentsFilter = (a, days, people) => {
  const person = people.find((p) => p.id === a.person_id);
  if (person?.is_placeholder) {
    return false;
  }
  if (Number(a.end_date) < Number(days[0])) {
    return false;
  }
  if (Number(a.start_date) > Number(days[days.length - 1])) {
    return false;
  }
  return true;
};
var generateKey = (date, projectId, personId, roleId, workstreamId) => `${date}-${projectId}-${personId}-${roleId}${workstreamId ? `-${workstreamId}` : ""}`;
var combinedProjectHours = ({
  actuals = [],
  assignments = [],
  rates = [],
  people = [],
  isTemplate = false
}) => {
  const todayNum = Number(formatToRunnDate2(/* @__PURE__ */ new Date()));
  const ratesObject = rates.reduce(
    (acc, val) => {
      acc[val.role_id] = val.rate;
      return acc;
    },
    {}
  );
  const peopleObject = people.reduce(
    (acc, val) => {
      acc[val.id] = val;
      if (val.id != null) {
        acc[val.id] = val;
      }
      return acc;
    },
    {}
  );
  const getBillableAmount = (minutes, roleId) => {
    const hourlyRate = ratesObject[roleId];
    if (!hourlyRate) {
      return 0;
    }
    return minutes / 60 * hourlyRate;
  };
  const combinedData = /* @__PURE__ */ new Map();
  assignments.forEach((a, _i) => {
    const roleId = a.role_id;
    const personId = a.person_id;
    const { runnDailyDates } = getTimeFrames({
      start: parseRunnDate2(a.start_date),
      end: parseRunnDate2(a.end_date),
      includeWeekends: a.non_working_day
    });
    const person = peopleObject[personId];
    const assignmentDays = runnDailyDates.map((x) => x.formattedDate).filter(
      (date) => !dateIsAHoliday(person?.time_offs || [], date) || a.non_working_day || isTemplate
    );
    const scheduled_billable_minutes = a.is_billable ? a.minutes_per_day : 0;
    const scheduled_nonbillable_minutes = a.is_billable ? 0 : a.minutes_per_day;
    assignmentDays.forEach((d) => {
      const isPastPlaceholder = person?.is_placeholder && Number(d) < todayNum;
      if (isPastPlaceholder && !isTemplate) {
        return;
      }
      const key = generateKey(
        d,
        a.project_id,
        personId,
        roleId,
        a.workstream_id || null
      );
      const scheduledCost = !person ? NaN : (scheduled_billable_minutes + scheduled_nonbillable_minutes) / 60 * getCostOnDay(d, person?.contracts);
      const billable_amount = getBillableAmount(
        scheduled_billable_minutes,
        roleId
      );
      const data = {
        project_id: a.project_id,
        person_id: a.person_id,
        role_id: a.role_id,
        date: d,
        has_actual: false,
        actual_billable_minutes: void 0,
        actual_billable_amount: void 0,
        actual_nonbillable_minutes: void 0,
        actual_cost: void 0,
        combined_billable_minutes: scheduled_billable_minutes,
        combined_billable_amount: billable_amount,
        combined_nonbillable_minutes: scheduled_nonbillable_minutes,
        combined_cost: scheduledCost,
        scheduled_billable_minutes,
        scheduled_billable_amount: billable_amount,
        scheduled_nonbillable_minutes,
        scheduled_cost: scheduledCost,
        is_placeholder: Boolean(person?.is_placeholder),
        phase_id: a.phase_id,
        workstream_id: a.workstream_id ?? null
      };
      combinedData.set(key, data);
    });
  });
  actuals.forEach((actual) => {
    const key = generateKey(
      actual.date,
      actual.project_id,
      actual.person_id,
      actual.role_id,
      actual.workstream_id || null
    );
    const roleId = actual.role_id;
    const personId = actual.person_id;
    const person = peopleObject[personId];
    const actualCost = !peopleObject[personId] ? NaN : (actual.billable_minutes + actual.nonbillable_minutes) / 60 * getCostOnDay(actual.date, peopleObject[personId]?.contracts);
    const billable_amount = getBillableAmount(actual.billable_minutes, roleId);
    const dataCombined = combinedData.get(key);
    if (dataCombined) {
      dataCombined.has_actual = true;
      dataCombined.actual_billable_minutes = actual.billable_minutes;
      dataCombined.actual_billable_amount = billable_amount;
      dataCombined.actual_nonbillable_minutes = actual.nonbillable_minutes;
      dataCombined.combined_billable_minutes = actual.billable_minutes;
      dataCombined.combined_billable_amount = billable_amount;
      dataCombined.combined_nonbillable_minutes = actual.nonbillable_minutes;
      dataCombined.combined_cost = actualCost;
      dataCombined.actual_cost = actualCost;
      dataCombined.phase_id = actual.phase_id;
    } else {
      const data = {
        project_id: actual.project_id,
        person_id: actual.person_id,
        role_id: actual.role_id,
        date: actual.date,
        has_actual: true,
        actual_billable_minutes: actual.billable_minutes,
        actual_billable_amount: billable_amount,
        actual_nonbillable_minutes: actual.nonbillable_minutes,
        actual_cost: actualCost,
        combined_billable_minutes: actual.billable_minutes,
        combined_billable_amount: billable_amount,
        combined_nonbillable_minutes: actual.nonbillable_minutes,
        combined_cost: actualCost,
        scheduled_billable_minutes: 0,
        scheduled_billable_amount: 0,
        scheduled_nonbillable_minutes: 0,
        scheduled_cost: 0,
        is_placeholder: Boolean(person?.is_placeholder),
        phase_id: actual.phase_id,
        workstream_id: actual.workstream_id ?? null
      };
      combinedData.set(key, data);
    }
  });
  return Array.from(combinedData.values());
};

// src/fullTimeEquivalent.ts
import { Decimal } from "decimal.js";
var toFullTimeEquivalentEffort = (args) => {
  const minutesOfEffort = new Decimal(args.minutesOfEffort);
  const fulltimeMinutesPerDay = new Decimal(args.fulltimeMinutesPerDay);
  const shouldRound = args.shouldRound ?? true;
  if (fulltimeMinutesPerDay.isNegative() || fulltimeMinutesPerDay.isZero()) {
    throw new Error("fulltimeMinutesPerDay must be as positive number");
  }
  const result = minutesOfEffort.dividedBy(fulltimeMinutesPerDay);
  return shouldRound ? result.toDecimalPlaces(2).toNumber() : result.toNumber();
};
var toMinutesPerDayOfEffort = (args) => {
  const fulltimeEquivalentEffort = new Decimal(args.fulltimeEquivalentEffort);
  const fulltimeMinutesPerDay = new Decimal(args.fulltimeMinutesPerDay);
  if (fulltimeEquivalentEffort.isNegative()) {
    throw new Error("fulltimeEquivalentEffort must be as positive number or 0");
  }
  if (fulltimeMinutesPerDay.isNegative() || fulltimeMinutesPerDay.isZero()) {
    throw new Error("fulltimeMinutesPerDay must be as positive number");
  }
  return fulltimeEquivalentEffort.times(fulltimeMinutesPerDay);
};

// src/calculateByDay.ts
function calculateByDay({
  actuals = [],
  assignments = [],
  rates = [],
  people = [],
  isTemplate = false
}) {
  const ratesObject = rates.reduce(
    (acc, val) => {
      acc[val.role_id] = val.rate;
      return acc;
    },
    {}
  );
  const personMap = /* @__PURE__ */ new Map();
  for (const person of people) {
    personMap.set(person.id, person);
  }
  const getBillableAmount = (minutes, roleId) => {
    const hourlyRate = ratesObject[roleId];
    if (!hourlyRate) {
      return 0;
    }
    return minutes / 60 * hourlyRate;
  };
  const combinedData = /* @__PURE__ */ new Map();
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  for (const a of assignments) {
    const scheduled_billable_minutes = a.is_billable ? a.minutes_per_day : 0;
    const scheduled_nonbillable_minutes = a.is_billable ? 0 : a.minutes_per_day;
    let start = parseRunnDate(a.start_date);
    let end = parseRunnDate(a.end_date);
    if (start.getTime() > end.getTime()) {
      const temp = start;
      start = end;
      end = temp;
    }
    const person = personMap.get(a.person_id);
    if (person?.is_placeholder && !isTemplate && start < today) {
      start = today;
    }
    const days = a.non_working_day ? eachDay(start, end) : eachWeekDay(start, end);
    days_loop:
      for (const date of days) {
        const formattedDate = formatToRunnDate(date);
        if (!a.non_working_day && !isTemplate && person !== void 0) {
          for (const time_off of person.time_offs) {
            switch (time_off.leave_type) {
              case "rostered-off":
              case "holiday": {
                const isSameDay = time_off.start_date === formattedDate;
                if (isSameDay) {
                  continue days_loop;
                }
              }
              case "annual": {
                const isPartialTimeOff = Boolean(time_off.minutes_per_day);
                if (isPartialTimeOff) {
                  continue;
                }
                const isWithinAnnualLeave = time_off.start_date <= formattedDate && time_off.end_date >= formattedDate;
                if (isWithinAnnualLeave) {
                  continue days_loop;
                }
              }
              default:
                continue;
            }
          }
        }
        const key = generateKey2(
          formattedDate,
          a.project_id,
          a.person_id,
          a.role_id,
          a.workstream_id || null
        );
        const scheduledCost = !person ? NaN : (scheduled_billable_minutes + scheduled_nonbillable_minutes) / 60 * getCostOnDay(formattedDate, person?.contracts);
        const billable_amount = getBillableAmount(
          scheduled_billable_minutes,
          a.role_id
        );
        const data = {
          project_id: a.project_id,
          person_id: a.person_id,
          role_id: a.role_id,
          date: formattedDate,
          has_actual: false,
          actual_billable_minutes: void 0,
          actual_billable_amount: void 0,
          actual_nonbillable_minutes: void 0,
          actual_cost: void 0,
          combined_billable_minutes: scheduled_billable_minutes,
          combined_billable_amount: billable_amount,
          combined_nonbillable_minutes: scheduled_nonbillable_minutes,
          combined_cost: scheduledCost,
          scheduled_billable_minutes,
          scheduled_billable_amount: billable_amount,
          scheduled_nonbillable_minutes,
          scheduled_cost: scheduledCost,
          is_placeholder: Boolean(person?.is_placeholder),
          phase_id: a.phase_id,
          workstream_id: a.workstream_id ?? null
        };
        combinedData.set(key, data);
      }
  }
  for (const actual of actuals) {
    const key = generateKey2(
      actual.date,
      actual.project_id,
      actual.person_id,
      actual.role_id,
      actual.workstream_id || null
    );
    const roleId = actual.role_id;
    const personId = actual.person_id;
    const person = personMap.get(personId);
    const actualCost = !person ? NaN : (actual.billable_minutes + actual.nonbillable_minutes) / 60 * getCostOnDay(actual.date, person.contracts);
    const billable_amount = getBillableAmount(actual.billable_minutes, roleId);
    const dataCombined = combinedData.get(key);
    if (dataCombined) {
      dataCombined.has_actual = true;
      dataCombined.actual_billable_minutes = actual.billable_minutes;
      dataCombined.actual_billable_amount = billable_amount;
      dataCombined.actual_nonbillable_minutes = actual.nonbillable_minutes;
      dataCombined.combined_billable_minutes = actual.billable_minutes;
      dataCombined.combined_billable_amount = billable_amount;
      dataCombined.combined_nonbillable_minutes = actual.nonbillable_minutes;
      dataCombined.combined_cost = actualCost;
      dataCombined.actual_cost = actualCost;
      dataCombined.phase_id = actual.phase_id;
    } else {
      const data = {
        project_id: actual.project_id,
        person_id: actual.person_id,
        role_id: actual.role_id,
        date: actual.date,
        has_actual: true,
        actual_billable_minutes: actual.billable_minutes,
        actual_billable_amount: billable_amount,
        actual_nonbillable_minutes: actual.nonbillable_minutes,
        actual_cost: actualCost,
        combined_billable_minutes: actual.billable_minutes,
        combined_billable_amount: billable_amount,
        combined_nonbillable_minutes: actual.nonbillable_minutes,
        combined_cost: actualCost,
        scheduled_billable_minutes: 0,
        scheduled_billable_amount: 0,
        scheduled_nonbillable_minutes: 0,
        scheduled_cost: 0,
        is_placeholder: Boolean(person?.is_placeholder),
        phase_id: actual.phase_id,
        workstream_id: actual.workstream_id ?? null
      };
      combinedData.set(key, data);
    }
  }
  return [...combinedData.values()];
}
function generateKey2(date, projectId, personId, roleId, workstreamId) {
  return `${date}-${projectId}-${personId}-${roleId}${workstreamId ? `-${workstreamId}` : ""}`;
}
function* eachDay(start, end) {
  const current = new Date(start);
  const endDate = new Date(end);
  const endTime = endDate.getTime();
  while (current.getTime() <= endTime) {
    yield new Date(current.getTime());
    current.setDate(current.getDate() + 1);
  }
}
function* eachWeekDay(start, end) {
  const current = new Date(start);
  const endDate = new Date(end);
  const endTime = endDate.getTime();
  while (current.getTime() <= endTime) {
    switch (current.getDay()) {
      case 0:
      case 6:
        break;
      default:
        yield current;
    }
    current.setDate(current.getDate() + 1);
  }
}

// src/calculateByDayContext.ts
function getCalculateByDayStrategy(cto = false) {
  if (cto) {
    return calculateByDay;
  }
  return combinedProjectHours;
}

// src/calculateByDayWithPhaseGrouping.ts
function calculateByDayWithPhaseGrouping({
  actuals = [],
  assignments = [],
  rates = [],
  people = [],
  isTemplate = false
}) {
  const ratesObject = rates.reduce(
    (acc, val) => {
      acc[val.role_id] = val.rate;
      return acc;
    },
    {}
  );
  const personMap = /* @__PURE__ */ new Map();
  for (const person of people) {
    personMap.set(person.id, person);
  }
  const getBillableAmount = (minutes, roleId) => {
    const hourlyRate = ratesObject[roleId];
    if (!hourlyRate) {
      return 0;
    }
    return minutes / 60 * hourlyRate;
  };
  const combinedData = /* @__PURE__ */ new Map();
  const assignmentIndex = /* @__PURE__ */ new Map();
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  for (const a of assignments) {
    const scheduled_billable_minutes = a.is_billable ? a.minutes_per_day : 0;
    const scheduled_nonbillable_minutes = a.is_billable ? 0 : a.minutes_per_day;
    let start = parseRunnDate(a.start_date);
    let end = parseRunnDate(a.end_date);
    if (start.getTime() > end.getTime()) {
      const temp = start;
      start = end;
      end = temp;
    }
    const person = personMap.get(a.person_id);
    if (person?.is_placeholder && !isTemplate && start < today) {
      start = today;
    }
    const days = a.non_working_day ? eachDay2(start, end) : eachWeekDay2(start, end);
    days_loop:
      for (const date of days) {
        const formattedDate = formatToRunnDate(date);
        if (!a.non_working_day && !isTemplate && person !== void 0) {
          for (const time_off of person.time_offs) {
            switch (time_off.leave_type) {
              case "rostered-off":
              case "holiday": {
                const isSameDay = time_off.start_date === formattedDate;
                if (isSameDay) {
                  continue days_loop;
                }
              }
              case "annual": {
                const isPartialTimeOff = Boolean(time_off.minutes_per_day);
                if (isPartialTimeOff) {
                  continue;
                }
                const isWithinAnnualLeave = time_off.start_date <= formattedDate && time_off.end_date >= formattedDate;
                if (isWithinAnnualLeave) {
                  continue days_loop;
                }
              }
              default:
                continue;
            }
          }
        }
        const key = generateKey3(
          formattedDate,
          a.project_id,
          a.person_id,
          a.role_id,
          a.workstream_id || null,
          a.phase_id
        );
        const indexKey = generateIndexKey(
          formattedDate,
          a.project_id,
          a.person_id,
          a.role_id,
          a.workstream_id || null
        );
        const scheduledCost = !person ? NaN : (scheduled_billable_minutes + scheduled_nonbillable_minutes) / 60 * getCostOnDay(formattedDate, person?.contracts);
        const billable_amount = getBillableAmount(
          scheduled_billable_minutes,
          a.role_id
        );
        const data = {
          project_id: a.project_id,
          person_id: a.person_id,
          role_id: a.role_id,
          date: formattedDate,
          has_actual: false,
          actual_billable_minutes: void 0,
          actual_billable_amount: void 0,
          actual_nonbillable_minutes: void 0,
          actual_cost: void 0,
          combined_billable_minutes: scheduled_billable_minutes,
          combined_billable_amount: billable_amount,
          combined_nonbillable_minutes: scheduled_nonbillable_minutes,
          combined_cost: scheduledCost,
          scheduled_billable_minutes,
          scheduled_billable_amount: billable_amount,
          scheduled_nonbillable_minutes,
          scheduled_cost: scheduledCost,
          is_placeholder: Boolean(person?.is_placeholder),
          phase_id: a.phase_id,
          workstream_id: a.workstream_id ?? null
        };
        combinedData.set(key, data);
        const existingAssignments = assignmentIndex.get(indexKey) || [];
        existingAssignments.push(data);
        assignmentIndex.set(indexKey, existingAssignments);
      }
  }
  for (const actual of actuals) {
    const key = generateKey3(
      actual.date,
      actual.project_id,
      actual.person_id,
      actual.role_id,
      actual.workstream_id || null,
      actual.phase_id
    );
    const indexKey = generateIndexKey(
      actual.date,
      actual.project_id,
      actual.person_id,
      actual.role_id,
      actual.workstream_id || null
    );
    const roleId = actual.role_id;
    const personId = actual.person_id;
    const person = personMap.get(personId);
    const actualCost = !person ? NaN : (actual.billable_minutes + actual.nonbillable_minutes) / 60 * getCostOnDay(actual.date, person.contracts);
    const billable_amount = getBillableAmount(actual.billable_minutes, roleId);
    const dataCombined = combinedData.get(key);
    const matchingAssignments = assignmentIndex.get(indexKey) || [];
    const assignmentWithDifferentPhase = matchingAssignments.find((record) => {
      if (record.has_actual || record.phase_id === actual.phase_id) {
        return false;
      }
      return true;
    });
    const recordDate = parseRunnDate(actual.date);
    const isPastDate = recordDate < today;
    const isFutureDate = !isPastDate;
    if (assignmentWithDifferentPhase && isPastDate) {
      assignmentWithDifferentPhase.combined_billable_minutes = 0;
      assignmentWithDifferentPhase.combined_billable_amount = 0;
      assignmentWithDifferentPhase.combined_nonbillable_minutes = 0;
      assignmentWithDifferentPhase.combined_cost = 0;
      assignmentWithDifferentPhase.has_actual_different_phase = true;
    }
    if (dataCombined) {
      if (isPastDate) {
        dataCombined.combined_billable_minutes = actual.billable_minutes;
        dataCombined.combined_billable_amount = billable_amount;
        dataCombined.combined_nonbillable_minutes = actual.nonbillable_minutes;
        dataCombined.combined_cost = actualCost;
      }
      dataCombined.has_actual = true;
      dataCombined.actual_billable_minutes = actual.billable_minutes;
      dataCombined.actual_billable_amount = billable_amount;
      dataCombined.actual_nonbillable_minutes = actual.nonbillable_minutes;
      dataCombined.actual_cost = actualCost;
      dataCombined.phase_id = actual.phase_id;
    } else {
      const data = {
        project_id: actual.project_id,
        person_id: actual.person_id,
        role_id: actual.role_id,
        date: actual.date,
        has_actual: true,
        actual_billable_minutes: actual.billable_minutes,
        actual_billable_amount: billable_amount,
        actual_nonbillable_minutes: actual.nonbillable_minutes,
        actual_cost: actualCost,
        combined_billable_minutes: isFutureDate && assignmentWithDifferentPhase ? 0 : actual.billable_minutes,
        combined_billable_amount: isFutureDate && assignmentWithDifferentPhase ? 0 : billable_amount,
        combined_nonbillable_minutes: isFutureDate && assignmentWithDifferentPhase ? 0 : actual.nonbillable_minutes,
        combined_cost: isFutureDate && assignmentWithDifferentPhase ? 0 : actualCost,
        scheduled_billable_minutes: 0,
        scheduled_billable_amount: 0,
        scheduled_nonbillable_minutes: 0,
        scheduled_cost: 0,
        is_placeholder: Boolean(person?.is_placeholder),
        phase_id: actual.phase_id,
        workstream_id: actual.workstream_id ?? null
      };
      combinedData.set(key, data);
    }
  }
  return [...combinedData.values()];
}
function generateKey3(date, projectId, personId, roleId, workstreamId, phaseId) {
  return `${date}-${projectId}-${personId}-${roleId}${workstreamId !== null ? `-${workstreamId}` : ""}${phaseId !== null ? `-${phaseId}` : ""}`;
}
function generateIndexKey(date, projectId, personId, roleId, workstreamId) {
  return `${date}-${projectId}-${personId}-${roleId}${workstreamId !== null ? `-${workstreamId}` : ""}`;
}
function* eachDay2(start, end) {
  const current = new Date(start);
  const endDate = new Date(end);
  const endTime = endDate.getTime();
  while (current.getTime() <= endTime) {
    yield new Date(current.getTime());
    current.setDate(current.getDate() + 1);
  }
}
function* eachWeekDay2(start, end) {
  const current = new Date(start);
  const endDate = new Date(end);
  const endTime = endDate.getTime();
  while (current.getTime() <= endTime) {
    switch (current.getDay()) {
      case 0:
      case 6:
        break;
      default:
        yield current;
    }
    current.setDate(current.getDate() + 1);
  }
}

// src/calculateByDayWithPhaseGroupingContext.ts
function getCalculateByDayByPhaseStrategy(cto = false) {
  if (cto) {
    return calculateByDayWithPhaseGrouping;
  }
  return combinedProjectHours;
}

// src/calculatePhaseBudget.ts
import { match as match2 } from "ts-pattern";
var NO_PHASE_ID = -1;
var OTHER_EXPENSES_ROLE_ID = -1;
var roundBudget = (amount) => {
  return amount % 10 < 1 ? Math.floor(amount) : Math.round(amount);
};
var getDefaultRate = (rateCard, roleId) => {
  if (rateCard.blended_rate_card) {
    return rateCard.blended_rate || 0;
  }
  const roleRate = rateCard.role_charge_out_rates.find(
    (r) => r.role_id === roleId
  );
  return roleRate?.charge_out_rate || 0;
};
var calculateEffectiveRate = (roleId, rateCard, projectRates) => {
  const projectRate = projectRates.find((rate) => rate.role_id === roleId);
  if (projectRate) {
    return projectRate.rate;
  }
  return getDefaultRate(rateCard, roleId);
};
var calculateRoleBudgetFromMinutesAndRate = (minutes, rate) => {
  if (!minutes)
    return 0;
  return roundBudget(minutes / 60 * rate);
};
var calculatePhaseBudget = ({
  budgetMethod,
  phase,
  ...input
}) => {
  return match2(budgetMethod).with("ROLE", () => null).with("PHASE", () => phase.revenue_budget ?? null).with("PHASE_AND_ROLE", () => {
    const { phaseRoles, rateCard, projectRates } = input;
    const relevantPhaseRoles = phaseRoles.filter((pr) => {
      if (phase.id === NO_PHASE_ID) {
        return pr.phase_id === null;
      }
      return pr.phase_id === phase.id;
    });
    return relevantPhaseRoles.reduce((total, phaseRole) => {
      const effectiveRate = calculateEffectiveRate(
        phaseRole.role_id,
        rateCard,
        projectRates
      );
      const roleBudget = calculateRoleBudgetFromMinutesAndRate(
        phaseRole.estimated_minutes,
        effectiveRate
      );
      return total + roleBudget;
    }, 0);
  }).exhaustive();
};
var getPhaseOtherExpenses = (otherExpensese, phaseId) => {
  return otherExpensese.filter((cost) => {
    if (phaseId === NO_PHASE_ID) {
      return cost.phase_id === null || cost.phase_id === void 0;
    }
    return cost.phase_id === phaseId;
  });
};
var calculateNoPhaseBudget = ({
  budgetMethod,
  noPhaseRevenueBudget,
  phaseRoles,
  rateCard,
  projectRates
}) => {
  return match2(budgetMethod).with("ROLE", () => 0).with("PHASE", () => noPhaseRevenueBudget ?? 0).with("PHASE_AND_ROLE", () => {
    const noPhasePhaseRoles = phaseRoles.filter((pr) => pr.phase_id === null);
    return noPhasePhaseRoles.reduce((total, phaseRole) => {
      const effectiveRate = calculateEffectiveRate(
        phaseRole.role_id,
        rateCard,
        projectRates
      );
      const roleBudget = calculateRoleBudgetFromMinutesAndRate(
        phaseRole.estimated_minutes,
        effectiveRate
      );
      return total + roleBudget;
    }, 0);
  }).exhaustive();
};

// src/calculateProjectBudget.ts
import { match as match3 } from "ts-pattern";
import numbro from "numbro";
var calculateMargin = (item) => {
  const { profit, charge } = item;
  const rawMargin = profit && charge ? profit / charge * 100 : 0;
  return numbro(rawMargin).format({
    optionalMantissa: true,
    mantissa: 0
  });
};
var addDerivedFieldsToExpense = (otherCost) => {
  const { cost, charge } = otherCost;
  const calculated = {
    ...otherCost,
    profit: charge - cost
  };
  return {
    ...calculated,
    margin: Number(calculateMargin(calculated))
  };
};
var calculateTotalExpenses = (otherCosts) => {
  const totalExpenses = otherCosts.reduce(
    (acc, curr) => {
      const cost = addDerivedFieldsToExpense(curr);
      const ret = {
        ...acc,
        profit: acc.profit + cost.profit,
        cost: acc.cost + cost.cost,
        charge: acc.charge + cost.charge
      };
      return ret;
    },
    {
      margin: "",
      profit: 0,
      cost: 0,
      charge: 0
    }
  );
  totalExpenses.margin = calculateMargin(totalExpenses);
  return totalExpenses;
};
var calculateProjectBudgetMinutes = ({
  budgetMethod,
  projectRoles,
  phaseRoles
}) => {
  return match3(budgetMethod).with("PHASE", () => 0).with(
    "ROLE",
    () => projectRoles.reduce((acc, pr) => (pr.estimated_minutes ?? 0) + acc, 0)
  ).with(
    "PHASE_AND_ROLE",
    () => phaseRoles.reduce((acc, pr) => (pr.estimated_minutes ?? 0) + acc, 0)
  ).exhaustive();
};
var calculateProjectBudgetHours = ({
  budgetMethod,
  projectRoles,
  phaseRoles
}) => {
  const minutes = calculateProjectBudgetMinutes({
    budgetMethod,
    projectRoles,
    phaseRoles
  });
  return minutes / 60;
};
var calculateProjectBudgetMinutesForRole = ({
  budgetMethod,
  projectRoles,
  phaseRoles,
  roleId
}) => {
  return match3(budgetMethod).with("PHASE", () => 0).with(
    "ROLE",
    () => projectRoles.find((pr) => pr.role_id === roleId)?.estimated_minutes ?? 0
  ).with("PHASE_AND_ROLE", () => {
    return phaseRoles.reduce((totalMinutes, pr) => {
      return pr.role_id === roleId ? totalMinutes + (pr.estimated_minutes ?? 0) : totalMinutes;
    }, 0);
  }).exhaustive();
};
var calculateRoleBudget = ({
  roles,
  projectRates,
  rateCard
}) => {
  return roles.reduce((total, role) => {
    if (role.id === OTHER_EXPENSES_ROLE_ID) {
      return total + (role.estimated_minutes ?? 0);
    }
    const effectiveRate = calculateEffectiveRate(
      role.id,
      rateCard,
      projectRates
    );
    const roleBudget = calculateRoleBudgetFromMinutesAndRate(
      role.estimated_minutes,
      effectiveRate
    );
    return total + roleBudget;
  }, 0);
};
export {
  NO_PHASE_ID,
  OTHER_EXPENSES_ROLE_ID,
  addDerivedFieldsToExpense,
  assignmentsVisibleDaysFilter,
  calculateEffectiveRate,
  calculateNoPhaseBudget,
  calculatePhaseBudget,
  calculateProjectBudgetHours,
  calculateProjectBudgetMinutes,
  calculateProjectBudgetMinutesForRole,
  calculateRoleBudget,
  calculateRoleBudgetFromMinutesAndRate,
  calculateTotalExpenses,
  date_exports as dateHelpers,
  eachDay,
  formatToRunnDate,
  getCalculateByDayByPhaseStrategy,
  getCalculateByDayStrategy,
  getCostOnDay,
  getPhaseOtherExpenses,
  parseRunnDate,
  realPeopleVisibleAssignmentsFilter,
  roundBudget,
  toFullTimeEquivalentEffort,
  toMinutesPerDayOfEffort
};
//# sourceMappingURL=index.js.map